const getLanguage = ({ user }) => user.getIn(['language'], 'en-US')

export default (state) => {
  return {
    language: getLanguage(state),
  }
}
